// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  companyName: "",
  apiServer: "https://m5nius1kad.execute-api.eu-west-2.amazonaws.com/1",
  clientToken: "5923c893836d57575284313d192d91973eacda27cf36bd3bacf4d685bb9834f6",
  companyId: 0,
  login: true,
  jrni: "",
  jrniAppId: "f6b16c23",
  jrniAppKey: "f0bc4f65f4fbfe7b4b3b7264b655f5eb",
  blJrniApi: "http://localhost:4201",
  sso: {
    "essex-staging": {
      clientId: "7ff33243-7da7-48bd-b4af-7e4b4a96afe9",
      authority: "a8b4324f-155c-4215-a0f1-7ed8cc9a992f",
      redirect: "https://ceremonyofficer.staging.bookinglab.co.uk/essex-staging/52500"
    }
    // "essex-staging": { BBOKINGLAB TEST FOR LOCAL
    //   clientId: "5b3f19c3-e0a2-4704-9c73-844021e9383d",
    //   authority: "99790039-f035-4127-9efe-6e8c7057d4ab",
    //   redirect: "https://localhost:4201/essex-staging/52500"
    // }
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
